<template>
  <d-modal :show-close="false" :isBgOverlay="true">
    <div slot="insertComponent" class="print-all-modal">
      <div class="print-calendars__header border-1-bottom text-dark">
        <h3>{{ $t('vue2.task_versions.print_latest_version') }}</h3>
        <div class="icon__bg-circle" @click="closeModal">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="print-all-modal__body">
        <div id="printTaskOverviews" v-if="!isShowUserSelectModal">
          <Loader v-if="isLoading" bgColor="#fff"></Loader>
          <template v-else>
            <h4 class="text-explainer" v-if="sortedUsers.length < 1">
              {{ $t('vue2.task_versions.no_saved_versions') }}
            </h4>
            <TaskOverviewUser
              v-for="user in filteredUsers"
              :key="user.user.id"
              :user="user.user"
              :version="user.version"
              :schoolThresholdToHideTaskHours="schoolThresholdToHideTaskHours"
              :isHideTaskHoursUnderThreshold="isHideTaskHoursUnderThreshold">
            </TaskOverviewUser>
          </template>
        </div>

      </div>
      <d-modal :show-close="false" :isBgOverlay="true" v-if="isShowUserSelectModal">
        <div class="d-modal__content d-modal__content__hide-task-hours" slot="insertComponent">
          <div class="brutto-container__header">
            <h3>Vælg brugere til udskrift</h3>
          </div>
          <div class="brutto-container__body">
            <!-- Filter tags -->
            <div class="brutto__users__header" v-if="tags.length > 0">
              <filterTags
                :users="usersSortedOnNameWithTags"
                :tags="tags"
                :selectedTags="appliedFilters"
                @set="setTagFromFilter"
                @remove="removeTagFromFilter">
              </filterTags>
            </div>

            <!-- Vælg alle / fjern alle -->
            <div class="brutto__users__list__header" @click="toggleAll">
              <span v-if="selectedUserIds.length < 1">{{ $t('vue2.tagging.select_all') }}</span>
              <span v-else>{{ $t('vue2.tagging.unselect_all') }}</span>
            </div>

            <!-- Brugerliste -->
            <ul class="brutto__users__list">
              <li
                class="brutto__users__user"
                v-for="user in filteredUsersOnTags"
                @click="toggleUser(user)"
                :class="{'is-selected': getIsUserSelected(user)}"
                :key="user.id">
                {{ user.name }}
              </li>
            </ul>
          </div>
          <div class="brutto-container__footer">
            <!-- Toggle for at skjule timepuljer -->
            <div class="input-group input-group__toggle" @click.stop="setIsHideTaskHoursUnderThreshold">
              <label class="d-label marg-1-right">Skjul timepuljer på opgaver under {{ schoolThresholdToHideTaskHours }}
                timer</label>
              <app-toggle :allowChanges="false" :propOn="isHideTaskHoursUnderThreshold"></app-toggle>
            </div>
            <!-- Knapper -->
            <div class="d-modal__print_buttons">
              <button class="do-bttn" @click="closeModal">{{ $t('vue2.common.cancel') }}</button>
              <button class="do-bttn do-bttn--submit" @click="startPrint"
                      :class="{'do-bttn--submit--loading': isLoadingPrint}">{{ $t('vue2.print_all_calendars.print') }}
              </button>
            </div>
          </div>

        </div>
      </d-modal>
    </div>
  </d-modal>
</template>

<script>
import DModal from '../common/DModal'
import TaskOverviewUser from '../User/TaskOverview/TaskOverviewUser'
import docendo from '../../docendo'
import Loader from '../common/Loader'
import AppToggle from '../common/AppToggle.vue'
import filterTags from '../Tagging/TaggingFilter'

export default {
  components: {AppToggle, Loader, DModal, TaskOverviewUser, filterTags},
  props: {
    schoolThresholdToHideTaskHours: {
      default: null
    },
    theUserCanManageAssignedHours: {
      default: false
    },
    tags: {
      default: () => []
    }
  },
  data () {
    return {
      versions: [],
      isLoading: false,
      isHideTaskHoursUnderThreshold: true,
      isShowUserSelectModal: true,
      selectedUserIds: [],
      isLoadingPrint: false,
      appliedFilters: [] // til tags
    }
  },
  computed: {
    usersSortedOnName () {
      return this.$store.getters.usersSortedOnName
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    // Sorteret brugerliste med tags (hvis dine user-objekter har tags på sig)
    usersSortedOnNameWithTags () {
      return this.usersSortedOnName.map(user => {
        user.tags = user.user_tags
        return user
      })
    },

    filteredUsersOnTags () {
      if (this.appliedFilters.length < 1) {
        return this.usersSortedOnNameWithTags
      }
      return this.usersSortedOnNameWithTags.filter(user => {
        if (!user.tags) return false
        return user.tags.some(tag => this.appliedFilters.includes(tag))
      })
    },
    sortedUsers () {
      const versions = this.versions.filter(version => this.allUsersInHash[version.user_id]).map(version => {
        return {
          name: this.allUsersInHash[version.user_id]['name'],
          user: this.allUsersInHash[version.user_id],
          version
        }
      })
      return this.$helpers.sortArrOnName(versions)
    },
    filteredUsers () {
      if (this.selectedUserIds.length < 1) {
        return this.sortedUsers
      }
      return this.sortedUsers.filter(user => this.selectedUserIds.includes(user.user.id))
    }
  },
  methods: {
    toggleUser (user) {
      const userId = user.id
      const index = this.selectedUserIds.indexOf(userId)
      if (index === -1) {
        this.selectedUserIds.push(userId)
      } else {
        this.selectedUserIds.splice(index, 1)
      }
    },

    getIsUserSelected (user) {
      return this.selectedUserIds.includes(user.id)
    },

    toggleAll () {
      if (this.selectedUserIds.length < 1) {
        this.selectedUserIds = this.filteredUsersOnTags.map(user => user.id)
      } else {
        this.selectedUserIds = []
      }
    },

    setTagFromFilter (tag) {
      if (!this.appliedFilters.includes(tag)) {
        this.appliedFilters.push(tag)
      }
    },

    removeTagFromFilter (tag) {
      const index = this.appliedFilters.indexOf(tag)
      if (index !== -1) {
        this.appliedFilters.splice(index, 1)
      }
    },
    startPrint () {
      this.isLoadingPrint = true
      this.$nextTick(_ => {
        this.isShowUserSelectModal = false
        this.$nextTick(_ => {
          this.isLoadingPrint = false
          this.print()
        })
      })
    },
    setIsHideTaskHoursUnderThreshold () {
      this.isHideTaskHoursUnderThreshold = !this.isHideTaskHoursUnderThreshold
    },
    closeModal () {
      this.$emit('close')
    },
    readAllOverviews () {
      this.isLoading = true
      docendo.readAllTaskOverview(this.schoolId, this.schoolYearId, success => {
        this.versions = success
        this.isLoading = false
        this.$nextTick(_ => {
          this.isShowUserSelectModal = true // Viser modal med bruger-valg
        })
      }, failure => {
        console.log({failure})
      })
    },
    print () {
      const i18nTaskOverview = this.$t('vue2.task_versions.task_overview')
      // https://stackoverflow.com/questions/52343006/how-to-print-a-part-of-a-vue-component-without-losing-the-style
      const prtHtml = document.getElementById('printTaskOverviews').innerHTML
      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"][href*="/app/static/css/"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Tving sideskift pr. medarbejder, så to opgaveoversigter aldrig deler samme side.
      // Denne regel er bevidst ikke afhængig af Vue scoped-CSS, da scoped-attributter
      // ikke altid overføres korrekt til print-vinduet.
      const pageBreakStyles = `<style>@media print {
        #printTaskOverviews .to-user { page-break-after: always; break-after: page; }
        #printTaskOverviews .to-user:last-child { page-break-after: auto; break-after: auto; }
      }</style>`
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html><html id="html-bg-white"><head><title>${i18nTaskOverview}</title>${stylesHtml}${pageBreakStyles}</head><body><div id="printTaskOverviews">${prtHtml}</div></body></html>`)
      var afterPrint = () => {
        WinPrint.close()
        this.closeModal()
      }
      WinPrint.onafterprint = afterPrint
      setTimeout(_ => {
        WinPrint.document.close()
        WinPrint.focus()
        WinPrint.print()
      }, 1000)
    }
  },
  mounted () {
    this.readAllOverviews()
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

html body, .print-all-modal {
  background: #fff;
}

.print-all-modal__body {
  max-height: calc(100vh - 80px);
  min-width: 800px;
  background: #fff;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.d-label {
  color: var(--dark-blue);
}

.d-modal__print_buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

.d-modal__content__hide-task-hours {
  padding: 0;
}

.brutto-container__body {
  flex-direction: column;
  max-height: 100%;
}

.brutto__users__list {
  max-height: calc(100vh - 100px - 50px - 60px - 30px);
  overflow-y: auto;
}

.brutto-container__footer {
  flex-direction: column;
}

.input-group__toggle {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// PrintTaskOverviews.vue?5eced0e0